import type { MultiSelectOption } from '@/components/ui/multi-select';

/**
 * The canonical KB-tag vocabulary — the knowledge categories the 25 agents
 * declare they read (their "Knowledge Base" sections). Offered as ready-made
 * options in the install KB-tag picker so scoping works from a consistent
 * vocabulary before anything is tagged. Tag your knowledge documents with these
 * same slugs for an agent's tag scope to match. Org-specific tags can still be
 * typed in (creatable); this is the shared baseline, not a hard limit.
 */
const TAGS_BY_GROUP: Record<string, { value: string; label: string }[]> = {
  'Brand & audience': [
    { value: 'brand-voice', label: 'Brand voice' },
    { value: 'positioning', label: 'Positioning' },
    { value: 'icp-persona', label: 'ICP / persona' },
  ],
  'Offer & proof': [
    { value: 'service-archetypes', label: 'Service archetypes' },
    { value: 'pricing', label: 'Pricing' },
    { value: 'case-studies', label: 'Case studies' },
    { value: 'agency-facts', label: 'Agency facts' },
  ],
  Market: [
    { value: 'vertical-dossier', label: 'Vertical dossier' },
    { value: 'demand-radar', label: 'Demand radar' },
  ],
  Delivery: [
    { value: 'engagement-charter', label: 'Engagement charter' },
    { value: 'spec', label: 'Spec / acceptance criteria' },
    { value: 'runbooks', label: 'Runbooks' },
  ],
  'Engineering & security': [
    { value: 'architecture', label: 'Architecture' },
    { value: 'test-architecture', label: 'Test architecture' },
    { value: 'security-baseline', label: 'Security baseline' },
  ],
  'Ops & governance': [
    { value: 'sops', label: 'SOPs' },
    { value: 'staffing', label: 'Staffing' },
    { value: 'legal-templates', label: 'Legal templates' },
  ],
};

/** Flat, grouped option list for the KB-tag MultiSelect. */
export const KB_TAG_OPTIONS: MultiSelectOption[] = Object.entries(TAGS_BY_GROUP).flatMap(
  ([group, tags]) => tags.map((t) => ({ ...t, group })),
);

/** Just the canonical slugs (for merge/dedup). */
export const KB_TAG_SLUGS: string[] = KB_TAG_OPTIONS.map((o) => o.value);
